import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { PersonaService } from "../servicios/persona.service";
import { UsuarioService } from "../servicios/usuario.service";
import { AgenciaService } from "../servicios/agencia.service";
import { Constants } from '../constants/constants';
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import * as _moment from "moment";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { Utils } from '../utils/utils';
import { ArchivosService } from '../servicios/archivos.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD"
  }
};

export interface Usuario {
  id: string;
  valor: string;
}

@Component({
  selector: "app-cargues-usuario",
  templateUrl: "./cargues-usuario.component.html",
  styleUrls: ["./cargues-usuario.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CarguesUsuarioComponent implements OnInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  haveData = false;
  loading = false;
  timeRunning = 0;
  entregasGroup: FormGroup;
  loadingAgencias = false;
  loadingUsuarios = false;
  usuarioConsulta = "";
  filteredUsuarios: Observable<Usuario[]>;
  agencias = [];
  usuarios = [];
  dataCargues=[];
  
  dtTrigger = new Subject();


  dtOptions: any = {
    pagingType: 'full_numbers',
    scrollX: true,
    dom: 'Bfrtip',
    buttons: [      
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ':visible'
        }
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ':visible'
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true }
      }
    ]
  };

  constructor(
    private fb: FormBuilder,
    private servicePersona: PersonaService,
    private serviceUsuario: UsuarioService,
    private serviceArchivo: ArchivosService,
    private servicioAgencia: AgenciaService,
    public ruta: Utils
  ) {
    const fechaHoy = new Date();
    const nFecha = _moment(fechaHoy, 'YYYY-MM-DD').format('YYYY-MM-DD');
    this.entregasGroup = this.fb.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required]
    });

    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.loadingAgencias = true;
    this.servicioAgencia
      .getAgencia(infoUsuario[0].IdUsuario, 0)
      .subscribe(result => {
        this.agencias = result;
        this.agencias.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["idAgencia"].setValue("0");
        this.loadingAgencias = false;
        this.entregasGroup.get("idAgencia").valueChanges.subscribe(value => {
          this.cargarUsuariosAgencia();
        });
        //console.log(this.agencias);
      });

    this.loadingUsuarios = true;
    this.serviceUsuario
      .getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0)
      .subscribe(result => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS"
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map(usuario =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });

      this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha);
  }

  ngOnInit() {
    this.ruta.setRuta();
  }


  busqueda() {


    //console.log(this.entregasGroup.get('idAgencia').value);  
    //return;
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.entregasGroup.get('idAgencia').value;
    const usuario = this.entregasGroup.get('usuarioCtrl').value;
    const fechaInicial = _moment(this.entregasGroup.get('fechaInicial').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const fechaFinal = _moment(this.entregasGroup.get('fechaFinal').value, 'YYYY-MM-DD').format('YYYY-MM-DD');    
    //console.log(tipoConsulta);
    //return;
    this.cargarInformacion(agencia, usuarioConsulta, usuario.id, fechaInicial, fechaFinal);
  }

  cargarInformacion(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal) {
    this.loading = true;
    this.serviceArchivo.getInformeCarguesRealizados(agencia, usuarioConsulta, usuario, fechaInicial, fechaFinal).subscribe(data => {
      this.dataCargues = data;
      this.loading = false;
      if (data.length > 0) {
        this.haveData = true;
      }

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }


  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }


  

  cargarUsuariosAgencia() {
    this.loadingUsuarios = true;
    const agencia = this.entregasGroup.get("idAgencia").value;

    this.serviceUsuario
      .getUsuariosPersonas(2, this.usuarioConsulta, agencia)
      .subscribe(result => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS"
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map(usuario =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      usuario => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }



  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }


  descargarArchivo(item){
    
      const rootUrl = Constants.ROOT_URL;
      const agencia=item.idAgencia;
      const archivo = item.idExPlanoXAgencia;
      const url = rootUrl+'/integracionSubida/'+agencia+'/'+archivo+'/'+archivo+'.csv'

      window.open(url);
    
    
  }
}
